import { safeHTML } from '../../../../../utils/safeHTML';
import { useTranslation } from '../../../../../translations';
import classNames from 'classnames';
import combineModifiers from '../../../../../utils/modifiers/combineModifiers';

export default function Title({ className, value, modifier }) {
  const { t } = useTranslation();

  return (
    <h2
      className={classNames(
        'universal-modal__title',
        className,
        {
          ['universal-modal__title_min']: t(value).length > 15,
        },
        ...combineModifiers('universal-modal__title', modifier),
      )}
    >
      {safeHTML(t(value))}
    </h2>
  );
}
